import axios from 'axios';

export const handleApiCall = async (method = '', url = '', data = {},token) => {
	let authToken = token?token:localStorage?.getItem('sessionToken');
	let axiosConfig = {
		method,
		url: `${process.env.REACT_APP_API}${url}`,
		headers: {
			Authorization: `Bearer ${authToken}`
		}
	};
	if (method !== 'get') axiosConfig['data'] = data;
	try {
		let response = await axios(axiosConfig);
		
		return response;
	} catch (error) {
	
		
		return error;
	}
};
